import PathwayRequirementSubmissionPanelEditorFieldListTemplate from './pathway-requirement-submission-panel-editor-field-list.component.html';
import './pathway-requirement-submission-panel-editor-field-list.component.scss';
import { PathwayRequirementSubmissionPanelEditorFieldListController }
    from './pathway-requirement-submission-panel-editor-field-list.controller';

/**
 * @ngdoc component
 * @name PathwayRequirementSubmissionPanelEditorFieldListComponent
 * @module portfolium.component.pathways.requirement.submissionPanel
 **/
export const PathwayRequirementSubmissionPanelEditorFieldListComponent = {
    bindings: {
        'pfTitle': '<',
        'listName': '<',
        'list': '<',
        'idKey': '<',
        'nameKey': '<',
        'hideCounter': '<',
        'showToggle': '<',
        'onItemClick': '&',
    },
    controller: PathwayRequirementSubmissionPanelEditorFieldListController,
    template: PathwayRequirementSubmissionPanelEditorFieldListTemplate,
}
